import React, { useState } from 'react';
// import ViewAbsence from '../../../HR/Employees/Absence/ViewAbsence/ViewAbsence';
import ViewAbsence from '../../../HR/Employees/AbsencesAndVacations/Absence/ViewAbsence';
import ViewWorkRequest from '../../../FLEET/WorkRequests/ViewWorkRequest/ViewWorkRequest';
import UpdateAttendanceAdjustment from '../../../HR/Raqeeb/AttendanceAdjustment/UpdateAttendanceAdjustment';
import EquipmentDetails from '../../../FLEET/Equipments/EquipmentDetails';
import NeatixModal from '../../../../components/Modal/NeatixModal';

// const ViewStaticForm = ({ data }) => {
//   const [show, setShow] = useState();
//   let Component = null;

//   // console.log(data);

//   // console.log(data);
//   switch (data.dynamicFormId) {
//     case '19b2d5d2-8864-4e5d-b07e-4c1713d07a3c': // طلب غياب
//       Component = <ViewAbsence ReferenceId={data.staticRefrenceId} />;
//       break;
//     case 'd9e918b3-b706-4281-a6e6-5101be1bcd63': // طلب صيانة
//       Component = <ViewWorkRequest ReferenceId={data.staticRefrenceId} isAme={true} />;
//       break;
//     case '664a4b6f-5849-4654-923e-854ea748ad50': // طلب إستئذان
//       Component = <UpdateAttendanceAdjustment id={data.staticRefrenceId} isAme={true} />;
//       break;

//     default:
//       <div> {Component} </div>;
//   }

//   return (
//     <div>
//       <button
//         type="button"
//         className="btn btn-outline-theme rounded-0 w-100 "
//         onClick={() => setShow(true)}>
//         عرض تفاصيــل الطلب
//       </button>

//       <NeatixModal
//         title={`${data.requestName} (${data.requestNumber}) `}
//         show={show}
//         setShow={setShow}
//         // fullscreen={true}
//         size="lg"
//         headerClassName="bg-theme bg-opacity-25 p-3"
//         bodyClassName="p-3">
//         {Component}
//       </NeatixModal>
//     </div>
//   );
// };

// export default ViewStaticForm;

const ViewStaticForm = ({ data }) => {
  const [show, setShow] = useState(false);

  const renderComponent = () => {
    switch (data.dynamicFormId) {
      case '19b2d5d2-8864-4e5d-b07e-4c1713d07a3c': // طلب غياب
        return <ViewAbsence ReferenceId={data.staticRefrenceId} />;
      case 'd9e918b3-b706-4281-a6e6-5101be1bcd63': // طلب صيانة
        return <ViewWorkRequest ReferenceId={data.staticRefrenceId} isAme={true} />;
      case '664a4b6f-5849-4654-923e-854ea748ad50': // طلب إستئذان
        return <UpdateAttendanceAdjustment id={data.staticRefrenceId} isAme={true} />;
      case 'af7c1cca-8dd2-4707-992f-4c9e1cc55558': // طلب اضافة مركــبة
        return <EquipmentDetails Id={data.staticRefrenceId} />;
      default:
        return <div>لا توجد تفاصيل لعرض هذا الطلب.</div>; // Fallback content
    }
  };

  return (
    <div>
      <button
        type="button"
        className="btn btn-outline-theme rounded-0 w-100"
        onClick={() => setShow(true)}
        aria-label="عرض تفاصيل الطلب">
        عرض تفاصيل الطلب
      </button>

      <NeatixModal
        title={`${data.requestName} (${data.requestNumber})`}
        show={show}
        setShow={setShow}
        // size="lg"
        size="xl"
        headerClassName="bg-theme bg-opacity-25 p-3"
        bodyClassName="p-3">
        {renderComponent()}
      </NeatixModal>
    </div>
  );
};

export default ViewStaticForm;
